/**
 * Amplify configuration — must be imported FIRST before any other
 * Amplify services are used. ES module imports are hoisted, so this
 * file must be the first import in main.tsx to ensure Amplify.configure()
 * runs before any generateClient() or auth calls at module level.
 */
import { Amplify } from "aws-amplify";
import outputs from "../amplify_outputs.json";

Amplify.configure(outputs);
